<template>
  <div class="app-email-confirmation-wrapper">
    <ConfirmBirthdate v-if="changeView === 'confirmBirthdate' && urlParametersValid" >
      <template v-for="slot in possibleChildSlotsFor('Birthdate')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ConfirmBirthdate>
    <Success
      v-if="changeView === 'success'"
      @done="backToHref"
    >
      <template v-for="slot in possibleChildSlotsFor(isAuthenticated ? 'Success' : 'SuccessNotLogged')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Success>
    <ErrorStep v-if="changeView === 'error'"
               @done="backToHref"
               :error-type="errorType"
    >
      <template v-for="slot in possibleChildSlotsFor(isAuthenticated ? 'Error' : 'ErrorNotLogged')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ErrorStep>
  </div>
</template>

<script>
import ConfirmBirthdate, {
  stepName as birthdateStep
} from '@/components/process/generic/ConfirmEmailVerification/Birthdate.vue'
import { mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'
import ErrorStep, { stepName as errorStepName } from '@/components/generic/ErrorStep.vue'
import Success from '@/components/generic/Success.vue'

export default {
  name: 'EmailConfirmationWrapper',
  data () {
    return {
      errorType: null
    }
  },
  props: {
    backButtonHref: {
      Type: String,
      default: '#'
    }
  },
  mounted () {
    this.startLoader()

    const urlParameters = new URLSearchParams(window.location.search)
    this.captureEmailConfirmationParameter({
      token: urlParameters.get('token'),
      solicitorId: urlParameters.get('solicitorID')
    })

    if (this.urlParametersValid) {
      this.switchView(birthdateStep)
    } else {
      this.errorType = 'invalidUrl'
      this.switchView(errorStepName)
    }

    this.stopLoader()
  },
  mixins: [
    transaction('confirmEmailVerification')
  ],
  methods: {
    ...mapMutations('emailConfirmation', [
      'captureEmailConfirmationParameter',
      'switchView'
    ]),
    backToHref () {
      window.location.href = this.getSlotText(this.isAuthenticated ? this.changeView + 'LoggedHrefStepper' : this.changeView + 'NotLoggedHrefStepper')
    }
  },
  computed: {
    ...mapGetters('emailConfirmation', [
      'getView',
      'urlParametersValid'
    ]),
    ...mapGetters([
      'isAuthenticated'
    ]),
    changeView () {
      return this.getView
    }
  },
  components: { Success, ErrorStep, ConfirmBirthdate }
}
</script>
